<template>
  <div class="user-request-card">
    <div class="d-flex align-center w-100 w-md-auto mb-md-0 mb-4">
      <avatar :literal="'ВК'" variant="primary" size="M" />
      <div class="ml-4 paragraph-m_h font-600">
        <div class="mb-1">{{ data.userFullName }} запрашивает доступ к&nbsp;вашему пространству</div>
        <div>
          <a :href="`mailto:${data.userName}`" class="link">{{ data.userName }}</a
          >,
          <span class="text-secondary">Cлужба поддержки</span>
        </div>
      </div>
    </div>

    <e-btn variant="secondary" class="ml-auto" :loading="isDeclineLoading" @click="handleDecline"> Отклонить </e-btn>
    <e-btn variant="primary" class="ml-4" :loading="isAcceptLoading" @click="handleAccept"> Пригласить </e-btn>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useUsersStore } from '../store/users';
import type { AccessRequest } from '../types/users';
import Avatar from '@/core/components/common/Avatar.vue';
import { EBtn } from '@/core/components/ui';

const props = defineProps<{
  data: AccessRequest;
}>();

const { declineAccessRequest, accessRequestAccept, getUsersInvitations } = useUsersStore();

const isDeclineLoading = ref(false);
const isAcceptLoading = ref(false);

const handleDecline = async () => {
  isDeclineLoading.value = true;
  await declineAccessRequest(props.data.id);
  isDeclineLoading.value = false;
};

const handleAccept = async () => {
  isAcceptLoading.value = true;
  await accessRequestAccept(props.data.id);

  await getUsersInvitations();

  isAcceptLoading.value = false;
};
</script>

<style scoped lang="scss">
.user-request-card {
  display: flex;
  align-items: center;

  padding: 16px;

  background-color: $main-bg-color;
  border: 1px solid $border-color-light;
  border-radius: $border-radius-l;

  @include sm-and-down {
    flex-wrap: wrap;
  }
}
</style>
